export default "__VITE_ASSET__BB7B_8P0__"